import React, { Dispatch, SetStateAction } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';

import CloseIcon from 'app/components/Icons/CloseIcon';
import CustomInput from 'app/components/CustomInput';
import { WorkersMakePayment } from 'app/utils/services/types/salary.type';
import { useSendWorkersToPayment } from 'app/utils/services/salaryServices';

import { WorkersCheck } from '../EmployeesTable/EmployeesTable';

import { closeBtn, dialogActions, dialogTitle, paperProps, title } from './AmountModal.sx';

interface Props {
  open: boolean;
  close: Dispatch<SetStateAction<boolean>>;
  selectedWorkers: WorkersCheck[];
  refetchSalaryData: () => void;
  handleNewPaymentPage: () => void;
}

const AmountModal = (props: Props) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const { open, close } = props;

  const sendWorkersToPayment = useSendWorkersToPayment();

  const onSubmit = (data: { amount: string }) => {
    const requestData: WorkersMakePayment = {
      amount: Number(data.amount),
      id_list: props.selectedWorkers.map((worker) => worker.id),
    };

    sendWorkersToPayment.mutate(requestData, {
      onSuccess: () => {
        close(false);
        reset();
        props.refetchSalaryData();
        props.handleNewPaymentPage();
      },
    });
  };

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: paperProps,
      }}
      onClose={() => {
        close(false);
        reset();
      }}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle sx={{ ...dialogTitle, mb: '28px' }}>
          <Typography sx={title}>Məbləği qeyd edin</Typography>
          <Button
            color={'tertiary'}
            onClick={() => {
              close(false);
              reset();
            }}
            sx={closeBtn}
          >
            <CloseIcon />
          </Button>
        </DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', pl: '40px', gap: '16px' }}>
          <CustomInput
            rest={{
              ...register('amount', {
                required: 'Məbləğ mütləqdir',
              }),
            }}
            title={'Məbləğ'}
            placeholder={'Məbləğ'}
            isValid={!!errors.amount}
            errorText={String(errors.amount?.message)}
          />
        </DialogContent>
        <DialogActions sx={dialogActions}>
          <Button type="submit" disabled={sendWorkersToPayment.isLoading}>
            Ödənişə keç
          </Button>
          <Button
            color={'secondary'}
            sx={{ ml: '0 !important' }}
            onClick={() => {
              close(false);
              reset();
            }}
          >
            İmtina et
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AmountModal;
